import React from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "antd";
import BatteryIndicator from "./BatteryIndicator";
import ListDropdown from "../ListDropdown";

function LockerCard({ locker, onClick, className, selectedHub }) {
  const { threeDotsPopoverId } = useSelector((state) => state.batteries);
  const {
    lockerId,
    status,
    batteryPercentage,
    batteryRegistrationNo,
    statusText,
  } = locker;
  const statusNum = Number(status);

  const bg = statusNum === 1 ? "bg-[#F5EDD5]" : "bg-[#F7F6F6]"; // 1 is AVAILABLE (empty)

  const isDoorOpen = locker?.doorStatus === 1; // or 1 depending on your API

  const currentLockerId = locker?.lockerId || locker?.id;
  const isPopoverOpen = threeDotsPopoverId === currentLockerId;

  return (
    <div
      onClick={onClick}
      className={`
        border
        hover:border-primary
        ${bg}
        ${statusNum !== 1 ? "cursor-pointer" : ""}
        h-[110px]
        p-3
        relative
        group
        ${className}
      `}
    >
      {statusNum === 1 && (
        <div
          className={`absolute top-2 right-2 z-20 ${
            isPopoverOpen ? "opacity-100" : "opacity-0 group-hover:opacity-100"
          } transition-opacity`}
          onClick={(e) => e.stopPropagation()}
        >
          <ListDropdown
            detail={{
              id: currentLockerId,
              lockerDbId: locker?.id,
              lockerId: locker?.lockerId,
              lockerSerialNumber: locker?.lockerSerialNumber || locker?.serialNumber,
              currentHubId: selectedHub,
              qrType: "locker",
              isLockerEmpty: true,
            }}
            alignment="vertical"
          />
        </div>
      )}

      {statusNum === 2 && ( // 2 is ASSIGNED (has battery)
        <>
          <p className="font-aileron font-semibold text-[10px] leading-none mb-1">
            {batteryRegistrationNo}
          </p>
          {statusText && (
            <p className="font-aileron font-normal text-[10px] leading-none text-dark-gray mt-1">
              {statusText}
            </p>
          )}
        </>
      )}

      {statusNum === 1 && ( // 1 is AVAILABLE (empty / no battery)
        <div className="flex gap-x-0.5">
          <img
            src="/assets/icons/battery/battery-disable.svg"
            alt="No Battery"
          />
          <p className="font-aileron font-semibold text-[10px] leading-none">
            No Battery
          </p>
        </div>
      )}

      {statusNum !== 1 && <BatteryIndicator percentage={batteryPercentage} />}

      <Tooltip placement="bottom" title={isDoorOpen ? "Unlocked" : "Locked"}>
        <img
          src={
            isDoorOpen
              ? "/assets/icons/battery/lock-open.svg"
              : "/assets/icons/battery/lock-closed.svg"
          }
          alt={isDoorOpen ? "Door open" : "Door closed"}
          className="absolute bottom-7 left-8 w-3.5 h-3.5 z-10 cursor-pointer"
        />
      </Tooltip>
      <span
        className="
          absolute
          left-3
          bottom-3
          p-1.5
          bg-[#FCFCFC]
          rounded-lg
          font-aileron font-semibold text-xs leading-none
        "
      >
        {lockerId}
      </span>
    </div>
  );
}

export default LockerCard;
